const WIRKUNGSGRADZYLINDER = 0.8;
const WIRKUNGSGRADFEDER = 0.75;

const VERSTELLBEREICH_ARRAY = [14, 25];
const KOLBENSTANGE_FLAECHE_ARRAY = [314.16, 314.16];

const HEBELARM_ARRAY = [35, 65];
const ANTRIEBE_MAX_NETTO_DREHMOMENT = [800, 4400];
const ANTRIEBE_ARRAY = ['ACP-035', 'ACP-065'];
const HUB_ARRAY = [70, 130];

const KOLBENSTANGE_DURCHMESSER_ARRAY = [20, 20];

const zylDurchmesser035 = [80, 100, 125, 160, 200];
const zylDurchmesser065 = [160, 200, 250, 300, 350];

const ZYLDURCHMESSER = [zylDurchmesser035, zylDurchmesser065];

const federPakete035 = [
    ['G1', 'H1'].reverse(), // 80
    ['G1', 'H1', 'F1', 'A2', 'B2'].reverse(), // 100
    ['A1', 'A2', 'B1', 'B2', 'E1', 'E2', 'F1', 'G1', 'H1'].reverse(), // 125
    ['A1', 'A2', 'B1', 'B2', 'E1', 'E2', 'F1', 'G1', 'H1'].reverse(), // 160
    ['A1', 'A2', 'B1', 'B2', 'E1', 'E2', 'F1', 'G1', 'H1'].reverse() // 200
];

const federPakete065 = [
    ['E1', 'E2', 'E3'].reverse(), // 160
    ['E1', 'E2', 'E3', 'A2', 'C2', 'D1'].reverse(), // 200
    ['E1', 'E2', 'E3', 'A2', 'C2', 'D1'].reverse(), // 250
    ['A1', 'A2', 'B1', 'C1', 'C2', 'D1', 'E1', 'E2', 'E3'].reverse(), // 300
    ['A1', 'A2', 'B1', 'C1', 'C2', 'D1', 'E1', 'E2', 'E3'].reverse() // 350
];

const FEDERPAKETEARRAY = [federPakete035, federPakete065];

const federRate035Obj = {
    A1: [31.1, 0],
    A2: [15.6, 0],
    B1: [31.1, 0],
    B2: [15.6, 0],
    E1: [33.79, 0],
    E2: [33.79, 0],
    F1: [15.918, 0],
    G1: [10.271, 0],
    H1: [2.733, 0]
};

const vorspannung035Obj = { A1: 110, A2: 140, B1: 90, B2: 110, E1: 175, E2: 125, F1: 65, G1: 60, H1: 130 };
const federPaketAnzahl035Obj = { A1: 1, A2: 1, B1: 1, B2: 1, E1: 1, E2: 1, F1: 1, G1: 1, H1: 1 };

const federRate065Obj = {
    A1: [75.33, 0],
    A2: [37.66, 0],
    B1: [75.33, 0],
    C1: [75.33, 0],
    C2: [37.66, 0],
    D1: [37.66, 0],
    E1: [33.79, 0],
    E2: [33.79, 0],
    E3: [33.79, 0]
};
const vorspannung065Obj = { A1: 285, A2: 285, B1: 250, C1: 150, C2: 200, D1: 150, E1: 108, E2: 90, E3: 70 };
const federPaketAnzahl065Obj = { A1: 1, A2: 1, B1: 1, C1: 1, C2: 1, D1: 1, E1: 1, E2: 1, E3: 1 };

const FEDERRATEARRAY = [federRate035Obj, federRate065Obj];
const VORSPANNUNGARRAY = [vorspannung035Obj, vorspannung065Obj];
const FEDERPAKETEANZAHLARRAY = [federPaketAnzahl035Obj, federPaketAnzahl065Obj];

const getHebelarm = (antriebsIndex: number) => {
    return HEBELARM_ARRAY[antriebsIndex];
};

const getWirkungsgradZylinder = () => {
    return WIRKUNGSGRADZYLINDER;
};

const acpBasis = {
    getHebelarm,
    getWirkungsgradZylinder,
    WIRKUNGSGRADZYLINDER,
    WIRKUNGSGRADFEDER,
    ANTRIEBE_MAX_NETTO_DREHMOMENT,
    HEBELARM_ARRAY,
    ANTRIEBE_ARRAY,
    KOLBENSTANGE_DURCHMESSER_ARRAY,
    ZYLDURCHMESSER,
    FEDERPAKETEARRAY,
    FEDERRATEARRAY,
    VORSPANNUNGARRAY,
    FEDERPAKETEANZAHLARRAY,
    HUB_ARRAY,
    VERSTELLBEREICH_ARRAY
};

export default acpBasis;
